/* global $:true */
import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-ajax-save-on-change]';
const PLUGIN_NAME = 'ajaxSaveOnChange';
const MODULE_NAME = 'app.core/modules/ajax-save-on-change';
const log = debug(MODULE_NAME);


log('registerd');

class AjaxSaveOnChange {

    constructor(element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.value = this.$element.val();
        this.initial = this.value;
        this.endpointUrl =  $(`meta[name="site.${this.$element.attr(this.options.endpointMethodAttr)}"]`).attr('content');
        this.$element.on('change', this.change.bind(this));

        log('AddToQuotePlugin', element);
    }

    change () {
      this.value = this.$element.val();
      log('change', this.$element, this.value, this.initial);

      if (this.isDirty) {
         this.submit();
      }
    }

    get isDirty () {
      const yesno = this.initial !== this.value;
      log('isDirty', this.$element, yesno);

      return yesno;
    }

    submit() {
        this.inputValue = this.value;
        log('submitted', this.$element);
        this.$element.attr('disabled', 'disabled');
        this.post();
    }

    onSuccess(result) {
        this.$element.removeAttr('disabled');

        if (typeof result.Success !== 'undefined' && result.Success) {
        }
        else {
            var errorList =
                typeof result.ValidationMessages !== 'undefined'
                    ? result.ValidationMessages
                    : Array();
            log('ajaxSaveOnChangeServerError', errorList);
            this.$element.val(this.initial);
        }
    }

    post() {
        const url = `${this.endpointUrl}?${this.options
            .endpointParam}=${this.inputValue}`;

        var token = $('#__AjaxAntiForgeryForm input[name="__RequestVerificationToken"]').val();
        log('accepting', this.$element, url);
        $.ajax({
            url,
            method: 'post',
            data: {
                __RequestVerificationToken: token
            },
            success: result => {
                this.onSuccess(result);
            },
            error: e => {
                log('ajaxSaveOnChangeAjaxError', e);
              this.$element.removeAttr('disabled');
              this.$element.val(this.initial);
            }
        }).done(() => {
            log('accepted', this.$element, url);
        });
    }

}

AjaxSaveOnChange.DEFAULTS = {
    endpointMethodAttr: 'data-endpoint-method',
    endpointParam: 'notes',
    submitErrorClassname: 'submit-error'
};

plugin(PLUGIN_NAME, AjaxSaveOnChange);

export function exec () {
  $(document).ready(() => {
    $(ELEMENT_SELECTOR)[PLUGIN_NAME]();
  });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/ajax-save-on-change/index.js